import { render, staticRenderFns } from "./ViewProject.vue?vue&type=template&id=585ebdac&"
import script from "./ViewProject.vue?vue&type=script&lang=ts&"
export * from "./ViewProject.vue?vue&type=script&lang=ts&"
import style0 from "./ViewProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports